export default "__VITE_ASSET__a52vq0KP__"